module.exports = __webpack_public_path__ + "static/media/apr.ecfc9cf8.jpg";